import { Heading2XL, Heading4XL } from "../typography";

import { AccordionFeatureSection } from "./components/sections/AccordionFeatureSection";
import { Card } from "./about/components/Card";
import { DarkCard } from "./about/components/DarkCard";
import { Footer } from "./footer/NewFooter";
import { Hero } from "./about/components/Hero";
import ProviderNavigation from "../ProviderNavigation";
import { coreValuesSections } from "./about/config/aboutConfig";

export default function AboutPage() {
  return (
    <div className="tw-relative tw-flex tw-h-full tw-flex-col tw-overflow-x-hidden tw-bg-white tw-bg-cover">
      <div className="tw-bg-[#01086A] tw-bg-[url('/landing_page_assets/backgrounds/bg4.jpg')] tw-bg-cover">
        <ProviderNavigation isDark />
        <div className="tw-relative tw-mx-auto tw-mt-[48px] tw-w-full tw-max-w-[1448px] tw-px-[20px] tw-pb-[64px] min440:tw-px-[76px]">
          <Hero />
        </div>
      </div>
      <Card />
      <DarkCard />
      <div className="tw-flex tw-flex-col tw-items-center tw-gap-y-[5em] tw-py-[5em] min440:tw-gap-y-[7.5em] min440:tw-py-[7.5em]">
        <Heading4XL className="tw-my-0 tw-hidden tw-w-1/2 tw-justify-center tw-text-center tw-text-blue-dark-3 min440:tw-flex">
          The way we operate comes back to our core values.
        </Heading4XL>
        <Heading2XL className="tw-my-0 tw-text-center tw-text-blue-dark-3 min440:tw-hidden">
          The way we operate comes back to our core values.
        </Heading2XL>
        <div className="tw-flex tw-max-w-[1448px] tw-items-center tw-px-[1.25em] min440:tw-px-[7.75em]">
          <AccordionFeatureSection
            sections={coreValuesSections}
            imageSrc="/landing_page_assets/about/About2.png"
            hasButton={false}
            className="tw-gap-x-[3em]"
          />
        </div>
      </div>
      <Footer
        title="Join"
        titleAccent="our team."
        description="We are looking for talented, driven individuals who are excited to work in a dynamic and innovative environment"
        isRounded
        hasSquiggle
        hasJobOpeningsButton
      />
    </div>
  );
}
